import {call, put, takeLatest} from "redux-saga/effects";
import globalDialerService from "./globalDialerService";
import {
    getTeamMembersFail, getTeamMembersStart,
    getTeamMembersSuccess,
    getVirtualNumbersFail, getVirtualNumbersStart,
    getVirtualNumbersSuccess,
    searchContactsFail,
    searchContactsStart,
    searchContactsSuccess, setCallEnvironment
} from "./globalDialerSlice";

function* searchContactsSaga(action) {
    try {
        const response = yield call(globalDialerService.searchContactFromElastic, action.payload);

        if (response.status === 'SUCCESS') {
            yield put(searchContactsSuccess(response.data.contactInfos));

        } else {
            yield put(searchContactsFail());
        }
    } catch (error) {
        yield put(searchContactsFail());
    }
}

function* getVirtualNumbersSaga(action) {
    try {
        const response = yield call(globalDialerService.getVirtualNumbers, action.payload);

        if (response.success && response?.data) {
            yield put(getVirtualNumbersSuccess(response.data.virtual_number));

            const virtualNumbers = response.data.virtual_number || [];
            const defaultNumber = virtualNumbers.filter(number => number.is_default === 1);

            const fromNumber = defaultNumber[0] ? defaultNumber[0].virtual_number : virtualNumbers[0] ? virtualNumbers[0].virtual_number : "";

            yield put(setCallEnvironment({ fromNumber: fromNumber }));
        } else {
            yield put(getVirtualNumbersFail());
        }
    } catch (error) {
        console.log(error);
        yield put(getVirtualNumbersFail());
    }
}

function* getTeamMembersSaga(action) {
    try {
        const response = yield call(globalDialerService.getTeamMembers, action.payload);

        if (response.status === 'success' && response?.data) {
            yield put(getTeamMembersSuccess(response.data));
        } else {
            yield put(getTeamMembersFail());
        }
    } catch (error) {
        console.log(error);
        yield put(getTeamMembersFail());
    }
}

export function* watchGlobalDialerSaga() {
    yield takeLatest(searchContactsStart.type, searchContactsSaga);
    yield takeLatest(getVirtualNumbersStart.type, getVirtualNumbersSaga);
    yield takeLatest(getTeamMembersStart.type, getTeamMembersSaga);
}